/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { DeleteServiceTypeModule } from './delete-service-type.module';
export { DeleteServiceTypeComponent } from './delete-service-type.component';
export { DeleteServiceTypeDialogConfig } from './types';